import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { CommonService } from 'src/app/services/common.service';

interface AuditLogTextComponent {
  auditLogId: number;
  author: string;
  logTime: string;
  message: string;
}

interface HistoryLogEntry {
  author: string;
  logTime: string;
  message: string;
}

@Component({
  selector: 'projects-history-logs',
  imports: [],
  templateUrl: './projects-history-logs.component.html',
  styleUrl: './projects-history-logs.component.scss'
})
export class ProjectsHistoryLogsComponent implements OnInit, OnChanges {
  @Input() projectId?: string | number;
  @Input() label: string = 'History logs';
  @Input() height: number = 180;

  historyLogEntries: HistoryLogEntry[] = [];
  isLoadingHistoryLogs: boolean = false;

  constructor(
    private projectsService: ProjectsService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.loadHistoryLogs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectId'] && !changes['projectId'].firstChange) {
      this.loadHistoryLogs();
    }
  }

  private loadHistoryLogs(): void {
    if (!this.projectId) return;

    const params = new HttpParams().set('size', '9999');

    this.isLoadingHistoryLogs = true;
    this.projectsService.listHistoryLogs(Number(this.projectId), { params }).subscribe({
      next: (response: any) => {
        const logs: AuditLogTextComponent[] = response?.data?.auditLogTextComponents || [];
        this.historyLogEntries = logs.map(log => this.buildHistoryLogEntry(log));
        this.isLoadingHistoryLogs = false;
      },
      error: (error: any) => {
        console.error('Error loading history logs:', error);
        this.historyLogEntries = [];
        this.isLoadingHistoryLogs = false;
      }
    });
  }

  private buildHistoryLogEntry(log: AuditLogTextComponent): HistoryLogEntry {
    return {
      author: (log.author || 'Unknown user').toUpperCase(),
      logTime: this.formatHistoryLogTime(log.logTime),
      message: (log.message || '').trim() || '-'
    };
  }

  private formatHistoryLogTime(logTime?: string): string {
    if (!logTime) return '';

    const date = new Date(logTime);
    return isNaN(date.getTime()) ? '' : this.commonService.formatDate(date);
  }
}
